export default {
    DATA: 'DD/MM/YYYY',
    DATA_HORA: 'DD/MM/YYYY [-] HH[h]',
    DATA_HORA_MINUTO: 'DD/MM/YYYY [-] HH[h] mm[min]',
    HORA: 'HH[h] mm[min]',
    DATA_HORA_PORTAL: 'DD/MM/YYYY HH:mm',
    DATA_HORA_PORTAL_PROCESSO_INTERNO: 'DD/MM/YYYY [às] HH:mm',
}
